import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RequestCancellationService {
  private cancelPending$ = new Subject<void>();

  get cancel$() {
    return this.cancelPending$.asObservable();
  }

  cancelAllPendingRequests(): void {
    this.cancelPending$.next();
  }
}
